import { useRegisteredQuery } from '~/queries';
import { getSkillWeights } from '~/monolith-api';

const KEY = 'skill-weights';

export function useGetSkillWeights() {
   return useRegisteredQuery([KEY], async () => {
      const { weights } = await getSkillWeights();

      return weights;
   });
}
